package one.healthium.uscreen.ui.blocks

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import one.healthium.uscreen.domain.models.SafeAreaEdge
import one.healthium.uscreen.domain.models.SpacerBlock

@Composable
fun ColumnScope.UScreenSpacerBlock(modifier: Modifier = Modifier, block: SpacerBlock) {
    val flex = block.flex
    val height = block.height
    val safeAreaHeight = resolveSafeAreaHeight(block.safeArea)
    val sizeModifier = when {
        flex != null -> Modifier.weight(flex)
        safeAreaHeight != null -> Modifier.height(safeAreaHeight + (height ?: 0).dp)
        height != null -> Modifier.height(height.dp)
        else -> Modifier.height(16.dp)
    }
    Spacer(modifier = modifier.then(sizeModifier))
}

@Composable
fun RowScope.UScreenSpacerBlockInRow(modifier: Modifier = Modifier, block: SpacerBlock) {
    val flex = block.flex
    val width = block.width
    val sizeModifier = when {
        flex != null -> Modifier.weight(flex)
        width != null -> Modifier.width(width.dp)
        else -> Modifier.width(16.dp)
    }
    Spacer(modifier = modifier.then(sizeModifier))
}

@Composable
private fun resolveSafeAreaHeight(edge: SafeAreaEdge?): Dp? {
    if (edge == null) return null
    val density = LocalDensity.current
    val insetPx = when (edge) {
        SafeAreaEdge.Bottom -> WindowInsets.navigationBars.getBottom(density)
        SafeAreaEdge.Top -> WindowInsets.statusBars.getTop(density)
    }
    return with(density) { insetPx.toDp() }
}
